<template>
  <div>{{balance}}</div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  name: 'ColumnLineQtyBalance',
  props: {
    rowId: {
      type: [Number, String],
      required: true
    }
  },
  created () {
    const line = this.line(this.rowId)
    this.localInQty = line.inWarehouseQty || 0
    this.localSysQty = line.inSystemQty || 0
    this.bus.$on(`line-in-qty-changed-${this.rowId}`, (qty) => this.localInQty = qty)
    this.bus.$on(`line-sys-qty-changed-${this.rowId}`, (qty) => this.localSysQty = qty)
  },
  data () {
    return {
      localInQty: 0,
      localSysQty: 0
    }
  },
  computed: {
    ...mapGetters({
      line: 'edit/line'
    }),
    balance () {
      return (this.localInQty - this.localSysQty) || ''
    }
  },
  beforeDestroy () {
    this.bus.$off(`line-in-qty-changed-${this.rowId}`)
    this.bus.$off(`line-sys-qty-changed-${this.rowId}`)
  },
  inject: ['bus']
}
</script>
